export const StandardPlanPrices: Record<string, number> = {
  COMPLETE: 1495.0,
  COMPLETE_CLIENT: 1270.0,
  COMPLETE_EMPLOYEE: 1270.0,
  COMPLETE_YEARLY: 59.0,

  PROFESSIONAL: 3948.0,
  PROFESSIONAL_CLIENT: 3355.0,
  PROFESSIONAL_EMPLOYEE: 3355.0,
  PROFESSIONAL_YEARLY: 99.0
};
